// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chat-text[data-v-3b8c3534]{margin:12px 0 24px;background-color:#fafbfc;border-radius:6px;line-height:1.5}.markdown-body[data-v-3b8c3534]{box-sizing:border-box;width:100%;max-height:480px;overflow-y:auto;margin:0 auto;padding:10px;font-size:14px;color:#333}", ""]);
// Exports
module.exports = exports;
